/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-24 14:18:07
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-06 12:55:01
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC/index.tsx
 */
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { store } from 'src/store';

import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
import RouteBlock from './RouteBlock';
//import { SALES_CHANNELS_MULTI_LANG_PROPS } from 'src/tools/constant';
import { SelectHOC } from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import { currentSelectedSize } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewSizeContainer/slice';
import { currentSelectedStyle } from 'src/constrains/SalesChannelStyleSelect/slice';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
// const _SelectHOC = (Component) => {
//   const _Component = (props) => {
//     // console.log('__isCurrentSalesChannel', props.__isCurrentSalesChannel);
//     const { __isCurrentSalesChannel, ...rest } = props;
//     const isOnPrimaryLanguage = useSelector(isPrimaryLanguage());
//     return __isCurrentSalesChannel ? (
//       <Component {...rest} isPrimary={isOnPrimaryLanguage} />
//     ) : null;
//   };
//   return _Component;
// };

const salesChannelMultiLanguageParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
  [EnumSalesChannelMultiLanguage.siteStyleInParams]: true,
  [EnumSalesChannelMultiLanguage.siteStyleForceUpdate]: true,
  [EnumSalesChannelMultiLanguage.siteStyleSizeInParams]: true,
};

const salesChannelMultiLanguageQueryParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  [EnumSalesChannelMultiLanguage.siteStyleInParams]: true,
  [EnumSalesChannelMultiLanguage.siteStyleSizeInParams]: true,
  //  salesChannelMultiLanguageUpdate: true,
};

const BasicPageHOC = (Component: any, obj) => {
  const {
    getState,
    convertDataFromReduxToServer,
    submit,

    getHasModified,
    getSalesChannel,
    getSalesChannelName,
    validation,
    //baseURL,
    getLoaded,
    hasRouteBlock,
    queryData,

    //testFunction,
  } = obj;

  const WrappedComponent = (props) => {
    const { isPrimary: isOnPrimaryLanguage } = props;
    // const multiProps = props[SALES_CHANNELS_MULTI_LANG_PROPS];
    // useGetPageLanguageList(multiProps);
    const currentLanguage = useQueryLanguageListContentEditor();
    const currentStyle = useSelector(currentSelectedStyle());
    const currentSize = useSelector(currentSelectedSize());

    const _d = useDispatch();
    const _history = useHistory();
    const _params: any = useParams();

    //const { uuid: saleChannelUuid } = _params;
    //console.log('queryData', currentLanguage, currentStyle, currentSize);
    React.useEffect(() => {
      if (queryData && currentStyle) {
        // console.log('queryData');
        queryData(_params, salesChannelMultiLanguageQueryParams, _history);
      }
    }, [currentLanguage, currentStyle, currentSize]); //每次变化重新抓取数据
    const hasModified = useSelector(getHasModified());
    const salesChannel = useSelector(getSalesChannel());
    const salesChannelName = useSelector(getSalesChannelName());
    const _l: { loaded: boolean } = getLoaded
      ? useSelector(getLoaded())
      : { loaded: true };
    const { loaded } = _l;

    const _getState = () => {
      const _state = store.getState();
      return getState()(_state);
    };
    const _submit = (state) => {
      const _data = convertDataFromReduxToServer(state);

      _d(
        submit({
          body: _data,
          params: salesChannelMultiLanguageParams,
          isPrimary: isOnPrimaryLanguage,
          urlParams: _params,
        }),
      );
    };

    const submitData = () => {
      _d(validation({ isPrimary: isOnPrimaryLanguage }));
      const _s = _getState();
      const { isDataValid } = _s;
      return {
        submitFunction: () => {
          _submit(_s);
        },
        isDataValid,
      };
    };

    const returnProps = {
      submitData,
      hasModified,
      salesChannel,
      salesChannelName,
      loaded,
      isOnPrimaryLanguage,
      currentStyle,
      currentSize,
      ...props,
    };
    return (
      <React.Fragment>
        {hasRouteBlock && <RouteBlock hasModified={hasModified} />}
        <Component {...returnProps} />
      </React.Fragment>
    );
  };
  return SelectHOC(WrappedComponent);
};
export default BasicPageHOC;
